var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6191 1.19065C18.1905 1.50806 18.6615 1.97911 18.9789 2.55045L30.5306 23.3435C31.4694 25.0333 30.8606 27.1641 29.1708 28.1028C28.6509 28.3917 28.0659 28.5433 27.4711 28.5433H4.36768C2.43468 28.5433 0.867676 26.9763 0.867676 25.0433C0.867676 24.4485 1.01926 23.8635 1.30813 23.3435L12.8598 2.55045C13.7986 0.860709 15.9294 0.251906 17.6191 1.19065ZM15.9194 21.5433C14.9529 21.5433 14.1694 22.3268 14.1694 23.2933C14.1694 24.2598 14.9529 25.0433 15.9194 25.0433C16.8859 25.0433 17.6694 24.2598 17.6694 23.2933C17.6694 22.3268 16.8859 21.5433 15.9194 21.5433ZM15.9194 9.29326C14.9529 9.29326 14.1694 10.0768 14.1694 11.0433V18.0433C14.1694 19.0098 14.9529 19.7933 15.9194 19.7933C16.8859 19.7933 17.6694 19.0098 17.6694 18.0433V11.0433C17.6694 10.0768 16.8859 9.29326 15.9194 9.29326Z",
    fill: "#135582"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOrange);
export default __webpack_public_path__ + "static/media/warning-orange.e097fb00724d37ac247ba004bc62cdc4.svg";
export { ForwardRef as ReactComponent };